import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import {
	Label,
	LoadingContainer,
	NoData,
	SectionWrapper,
} from './ChartList.styles';
import {
	ApLoaderDefault,
	ApLoaderText,
	ApSimpleDropdown,
} from '@alixpartners/ui-components';
import { useVendorsByCategoryContext } from 'contexts/SupplierDiversity/VendorsByCategoryProvider';
import Header from 'SupplierDiversity/components/Header/Header';
import Filter from 'SupplierDiversity/components/Filter/Filter';

const chartTitle = 'Vendors By Category';
const VendorsByCategory = () => {
	const {
		isLoading,
		data,
		options,
		certificationFilter,
		certificationFilterHandler,
	} = useVendorsByCategoryContext();
	return (
		<SectionWrapper>
			<Header chartTitle={chartTitle}>
				{!isLoading && (
					<Filter>
						<div>
							<Label>Certifications:</Label>
						</div>
						<div>
							<ApSimpleDropdown
								options={certificationFilter.options}
								selected={certificationFilter.selected}
								onChange={certificationFilterHandler}
							/>
						</div>
					</Filter>
				)}
			</Header>
			{isLoading ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{data.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<HighchartsReact highcharts={Highcharts} options={options} />
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default VendorsByCategory;
